import { apiSlice } from '../../../store/api/apiSlice';
import type { MemberPreviewArgs, MemberPreviewResponse } from './memberPreviewTypes';

export function memberPreviewQuery({ kind, viewerTimezone }: MemberPreviewArgs) {
  return {
    url: '/appointments/member-preview',
    params: { kind, viewer_timezone: viewerTimezone },
  };
}

export function isBusyUnavailableError(error: unknown): boolean {
  const candidate = error as { status?: unknown; data?: { error?: unknown } } | undefined;
  return candidate?.status === 503 && candidate.data?.error === 'busy_unavailable';
}

export function viewerTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch {
    return 'UTC';
  }
}

export const memberPreviewApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMemberPreview: builder.query<MemberPreviewResponse, MemberPreviewArgs>({
      query: memberPreviewQuery,
      // Availability, calendars and busy change outside this view; never show a stale preview.
      keepUnusedDataFor: 0,
      // Calendar selection/connection and out-of-office changes invalidate
      // CalendarSettings; availability saves invalidate MemberPreview.
      providesTags: ['CalendarSettings', 'MemberPreview'],
    }),
  }),
});

export const { useGetMemberPreviewQuery } = memberPreviewApi;
